import { Navigate, Outlet } from 'react-router-dom';
import { usePartnershipsAccess } from '@/hooks/usePartnerships';
import { WinclapLoader } from '@/components/ui/winclap-loader';

/**
 * Gate del Partnerships Hub. Antes las rutas se abrían para cualquier usuario
 * autenticado y el filtro real vivía en el backend: quien no tenía acceso entraba
 * igual y veía el hub VACÍO (o "Producto no encontrado" en las páginas de detalle),
 * sin ninguna pista de que le faltaba permiso. Eso es exactamente el FORBIDDEN
 * silencioso que prohíbe la política de roles y visibilidad del repo: si una página
 * se puede abrir, sus queries load-bearing tienen que responder.
 *
 * `checkAccess` usa `privateProcedure` y nunca tira error, así que sirve de gate.
 * El acceso lo resuelve el governance config-driven contra el community map
 * (equipos viewer base + editores por email), no un rol de Cognito.
 */
export function PartnershipsProtectedRoute() {
  const { data: access, isLoading } = usePartnershipsAccess();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <WinclapLoader size={48} className="text-foreground/25" />
      </div>
    );
  }

  if (!access?.canView) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
